import { CaseReducer, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IKararDestekState } from "src/models/KararDestek/IKararDestekState";
import VwKdKullaniciRolDTO from "src/models/KararDestek/VwKdKullaniciRolDTO";
import VwKullaniciEkranraporDTO from "src/models/Print/VwKullaniciEkranraporDTO";

const KararDestekSlice = createSlice<IKararDestekState, {
    setState: CaseReducer<IKararDestekState, PayloadAction<IKararDestekState>>,
    // setData: CaseReducer<IKararDestekState, PayloadAction<Array<VwKdKullaniciRolDTO>>>,
    // setFetching: CaseReducer<IKararDestekState, PayloadAction<boolean>>,
    setLoading: CaseReducer<IKararDestekState, PayloadAction<boolean>>,
    setRaporSorgu: CaseReducer<IKararDestekState, PayloadAction<VwKdKullaniciRolDTO>>,
    setAramaKriterleri: CaseReducer<IKararDestekState, PayloadAction<any>>,
    setSablonEkleniyor: CaseReducer<IKararDestekState, PayloadAction<boolean>>,
    setReportGuid: CaseReducer<IKararDestekState, PayloadAction<string>>,
}>({
    name: 'kararDestek',
    initialState: {
        data: [],
        isFetching: true,
        rol: {
            key: -1,
            value: ""
        },
        loading: false,
        errorMessage: "",
        roller: [],
        raporSorgu: new VwKdKullaniciRolDTO(),
        aramaKriterleri: {},
        sablonEkleniyor: false,
        reportGuid: "",
        open: false,
        parameters: [],
        mailOpen: false,
        print: false,
        openDialog: false,
        kullaniciEkranraporDTO: new VwKullaniciEkranraporDTO(),
        sabitRow: {
            ekranKodu: "",
            modulId: null,
            onItemClick: null,
            params: {
                errorMessage: "",
                parameters: []
            },
            onViewerClose: null
        },
        openId: 0
    },
    reducers: {
        // setData: (state, action) => {
        //     state.data = action.payload
        // },
        // setFetching: (state, action) => {
        //     state.isFetching = action.payload
        // },
        // setLoading: (state, action) => {
        //     state.loading = action.payload
        // },
        // setRol: (state, action) => {
        //     state.rol = action.payload
        // },
        // setError: (state, action) => {
        //     state.errorMessage = action.payload
        // },
        setState: (state, action) => action.payload,
        setLoading: (state, action) => {
            state.loading = action.payload
        },
        setRaporSorgu: (state, action) => {
            state.raporSorgu = action.payload
        },
        setAramaKriterleri: (state, action) => {
            state.aramaKriterleri = action.payload
        },
        setSablonEkleniyor: (state, action) => {
            state.sablonEkleniyor = action.payload
        },
        setReportGuid: (state, action) => {
            state.reportGuid = action.payload
        },
    }
})
export default KararDestekSlice;